import {styleRule, StyleSheet} from "../../stem-core/ui/Style";
import {registerStyle} from "../../stem-core/ui/style/Theme";
import {UI} from "../../stem-core/ui/UIBase";
import {UserPreferences, Wallet} from "../State.js";
import {Messages} from "../Messages.js";
import {Money} from "../../stem-core/localization/Money.js";
import {wrapInSpinner} from "../../core/ui/LoadingSpinner.jsx";
import {apiUpdatePreferences} from "../../client/state/UserPreferencesStore.js";
import {autoredraw} from "../../stem-core/decorators/AutoRedraw";
import {ToggleInput} from "../../stem-core/ui/input/checkbox/ToggleInput.jsx";
import {MakeInfoElement} from "../../dashboard/common/InfoTooltip.jsx";


class AutoReloadStyle extends StyleSheet {
    @styleRule
    flexContainer = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    };
}

@registerStyle(AutoReloadStyle)
@autoredraw(UserPreferences, Wallet)
export class AutoReloadToggle extends UI.Element {
    render() {
        const {styleSheet} = this;
        const userPreferences = UserPreferences.getPreferences();

        const {autoTopUpEnabled} = userPreferences;
        const currency = Wallet.getWallet().getCurrency();

        // TODO these should have been extracted with @field
        const autoTopUpAmount = new Money(userPreferences.autoTopUpAmount, currency);
        const autoTopUpThreshold = new Money(userPreferences.autoTopUpThreshold, currency);

        const infoContent = () => <div>
            {Messages.autoReloadWallet(autoTopUpAmount, autoTopUpThreshold, currency)}
        </div>;

        return [
            <div className={styleSheet.flexContainer}>
                <div>
                    {Messages.autoReload} {MakeInfoElement(infoContent)}
                </div>
                <ToggleInput
                    testId="walletAutoReloadToggle"
                    ref="autoReloadToggle"
                    initialValue={autoTopUpEnabled}
                    onChange={(active) => this.updateAutoReload(active)}
                />
            </div>
        ];
    }

    @wrapInSpinner
    async updateAutoReload(autoTopUpEnabled: boolean) {
        await apiUpdatePreferences({autoTopUpEnabled});
    }
}
